import React, { useState, useEffect } from "react";
import useWindowDimensions from "../../../../components/get-diemensions/UseWindowDiemensions";
import {
  BaseButtons,
  TextInputFieldSearch,
} from "../../../../components/atoms";
import { BlackAndWhite } from "../../../../themes/Colors";
import { Section21Manage } from "./components";

const Section21Display = ({ admin, setLoading, loading }) => {
  const { width, height } = useWindowDimensions();
  const [search, setSearch] = useState("");
  const [displayView, setDisplayView] = useState("requested");

  const [section21Array, setSection21Array] = useState(null);
  const [prescriptionArray, setPrescriptionArray] = useState(null);

  const [refresh, setRefresh] = useState(false);

  const [slectedSection21, setSelectedSection21] = useState(null);
  const [allValidatedUsers, setAllValidatedUsers] = useState(null);

  const getAllsection21 = async () => {
    setLoading(true);
    try {
      const response = await fetch(
        "https://budloungedatabase.onrender.com/requestPrescriptionUser/getAllSection21andRequests",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            userId: admin.userId,
          }),
        }
      );

      const responseData = await response.json();

      if (responseData.success) {
        setSection21Array(responseData.section21);
        setPrescriptionArray(responseData.prescriptionRequest);
        setAllValidatedUsers(responseData.validatedUsers);
        setLoading(false);
      }
    } catch (err) {
      setLoading(false);
      console.log("error", err);
    }
  };

  useEffect(() => {
    if (admin) {
      getAllsection21();
    }
  }, [refresh]);
  return (
    <div
      style={{
        flex: 1,
        height: height - 60,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div
        style={{
          minHeight: 50,
          width: "100%",
          display: "flex",
          alignItems: "center",
        }}
      >
        <div style={{ minWidth: 5 }} />
        <TextInputFieldSearch
          placeholder={"type here to search"}
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          height={30}
        />
        <div style={{ minWidth: 5 }} />
        <BaseButtons
          mini={true}
          marginTopFalse={true}
          label={"CLEAR"}
          height={35}
          size={80}
          onClick={() => setSearch("")}
        />
        {/* <div style={{ minWidth: 5 }} />
        <BaseButtons
          mini={true}
          marginTopFalse={true}
          label={"SEARCH"}
          height={35}
          size={80}
        /> */}
        <div style={{ flex: 1 }} />
        <div style={{ minWidth: 5 }} />
        <BaseButtons
          mini={true}
          marginTopFalse={true}
          label={"APPROVED BY YOU"}
          height={35}
          size={120}
          invert={displayView === "approved" ? false : true}
          onClick={() => setDisplayView("approved")}
        />

        {/* <div style={{ minWidth: 5 }} />
        <BaseButtons
          mini={true}
          marginTopFalse={true}
          label={"PENDING REVIEW"}
          height={35}
          size={160}
          invert={displayView === "pending review" ? false : true}
          onClick={() => setDisplayView("pending review")}
        /> */}
        <div style={{ minWidth: 5 }} />
        <BaseButtons
          mini={true}
          marginTopFalse={true}
          label={"REQUESTED"}
          height={35}
          size={120}
          marginRight={5}
          invert={displayView === "requested" ? false : true}
          onClick={() => setDisplayView("requested")}
        />
      </div>
      <div
        style={{
          flex: 1,
          width: "100%",
          //   borderStyle: "solid",
          display: "flex",
          overflowY: "scroll",
          scrollbarWidth: "thin",
          overflowX: "hidden",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        {displayView === "requested"
          ? section21Array
            ? section21Array.map((item, index) => {
                return item.status === "REQUESTED" &&
                  item.idNumber.match(search) ? (
                  <div
                    onClick={() => setSelectedSection21(item)}
                    key={index}
                    style={{
                      minHeight: 150,
                      maxHeight: 150,
                      width: "98.5%",
                      display: "flex",
                      borderBottomStyle: "solid",
                      borderBottomWidth: 1,
                      borderTopStyle: "solid",
                      borderTopWidth: 1,
                      marginTop: 10,
                      alignItems: "center",
                      borderColor: "#00000050",
                    }}
                  >
                    <div
                      style={{
                        flex: 0.2,
                        display: "flex",
                        flexDirection: "column",
                        borderRightStyle: "solid",
                        borderRightWidth: 1,
                        height: "90%",
                        borderColor: "#00000050",
                      }}
                    >
                      <div
                        style={{
                          // marginTop: 10,
                          marginLeft: 10,
                          fontWeight: "bold",
                          fontSize: 14,
                        }}
                      >
                        PATIENT INFO
                      </div>
                      <div style={{ marginTop: 10, marginLeft: 10 }}>
                        <div style={{ fontSize: 10, fontWeight: "bold" }}>
                          Patient Name:
                        </div>
                        <div style={{ fontSize: 12, marginTop: 3 }}>
                          {item.fullNames + " " + item.surname}
                        </div>
                      </div>
                      <div style={{ marginTop: 5, marginLeft: 10 }}>
                        <div style={{ fontSize: 10, fontWeight: "bold" }}>
                          Contact Number:
                        </div>
                        <div style={{ fontSize: 12, marginTop: 3 }}>
                          {item.cellNumber}
                        </div>
                      </div>
                      <div style={{ marginTop: 5, marginLeft: 10 }}>
                        <div style={{ fontSize: 10, fontWeight: "bold" }}>
                          Email Address:
                        </div>
                        <div style={{ fontSize: 12, marginTop: 3 }}>
                          {item.emailAddress}
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        flex: 0.6,
                        display: "flex",
                        flexDirection: "column",
                        borderRightStyle: "solid",
                        borderRightWidth: 1,
                        height: "90%",
                        borderColor: "#00000050",
                      }}
                    >
                      <div
                        style={{
                          // marginTop: 10,
                          marginLeft: 10,
                          fontWeight: "bold",
                          fontSize: 14,
                        }}
                      >
                        SECTION 21 INFO
                      </div>
                      <div
                        style={{
                          flex: 1,

                          display: "flex",
                          justifyContent: "center",
                          fontSize: 16,
                          fontWeight: "normal",
                          // alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            flex: 0.25,
                            maxWidth: "25%",
                            overflowX: "clip",
                          }}
                        >
                          <div style={{ marginTop: 10, marginLeft: 10 }}>
                            <div style={{ fontSize: 10, fontWeight: "bold" }}>
                              DATE CREATED
                            </div>
                            <div style={{ marginTop: 3 }}>{item.createdOn}</div>
                          </div>
                          <div style={{ marginTop: 10, marginLeft: 10 }}>
                            <div style={{ fontSize: 10, fontWeight: "bold" }}>
                              REFERENCE NO
                            </div>
                            <div style={{ marginTop: 3, fontSize: 12 }}>
                              {item.id}
                            </div>
                          </div>
                        </div>
                        <div style={{ flex: 0.25 }}>
                          <div style={{ marginTop: 10, marginLeft: 10 }}>
                            <div style={{ fontSize: 10, fontWeight: "bold" }}>
                              LINKED STORE
                            </div>
                            <div style={{ marginTop: 3, fontSize: 12 }}>
                              {item.storeName}
                            </div>
                          </div>
                          <div style={{ marginTop: 10, marginLeft: 10 }}>
                            <div style={{ fontSize: 10, fontWeight: "bold" }}>
                              STORE ADDRESS
                            </div>
                            <div style={{ marginTop: 3, fontSize: 12 }}>
                              {item.storeAddress}
                            </div>
                          </div>
                        </div>
                        <div style={{ flex: 0.25 }}>
                          <div style={{ marginTop: 10, marginLeft: 10 }}>
                            <div style={{ fontSize: 10, fontWeight: "bold" }}>
                              REASON FOR REQUEST
                            </div>
                            <div style={{ marginTop: 3, fontSize: 12 }}>
                              {item.diagnosis}
                            </div>
                          </div>
                        </div>
                        <div style={{ flex: 0.25 }}>
                          <div style={{ marginTop: 10, marginLeft: 10 }}>
                            <div
                              style={{
                                fontSize: 10,
                                fontWeight: "bold",
                                width: "100%",
                                textAlign: "center",
                              }}
                            >
                              STATUS
                            </div>
                            <div
                              style={{
                                marginTop: 3,
                                fontSize: 12,
                                width: "100%",
                                textAlign: "center",
                              }}
                            >
                              {item.status}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        flex: 0.2,
                        backgroundColor: BlackAndWhite.primary,
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-evenly",
                        flexDirection: "column",
                      }}
                    >
                      <div style={{ color: BlackAndWhite.secondary }}>
                        ACTIONS
                      </div>
                      <BaseButtons
                        invert={true}
                        mini={true}
                        label={"MANAGE"}
                        marginTopFalse={true}
                        height={40}
                        size={"80%"}
                      />
                    </div>
                  </div>
                ) : null;
              })
            : null
          : null}
        {displayView === "approved"
          ? section21Array
            ? section21Array.map((item, index) => {
                return item.status === "PENDING REVIEW" &&
                  item.doctorId === admin.userId &&
                  item.idNumber.match(search) ? (
                  <div
                    onClick={() => setSelectedSection21(item)}
                    key={index}
                    style={{
                      minHeight: 150,
                      maxHeight: 150,
                      width: "98.5%",
                      display: "flex",
                      borderBottomStyle: "solid",
                      borderBottomWidth: 1,
                      borderTopStyle: "solid",
                      borderTopWidth: 1,
                      marginTop: 10,
                      alignItems: "center",
                      borderColor: "#00000050",
                    }}
                  >
                    <div
                      style={{
                        flex: 0.2,
                        display: "flex",
                        flexDirection: "column",
                        borderRightStyle: "solid",
                        borderRightWidth: 1,
                        height: "90%",
                        borderColor: "#00000050",
                      }}
                    >
                      <div
                        style={{
                          // marginTop: 10,
                          marginLeft: 10,
                          fontWeight: "bold",
                          fontSize: 14,
                        }}
                      >
                        PATIENT INFO
                      </div>
                      <div style={{ marginTop: 10, marginLeft: 10 }}>
                        <div style={{ fontSize: 10, fontWeight: "bold" }}>
                          Patient Name:
                        </div>
                        <div style={{ fontSize: 12, marginTop: 3 }}>
                          {item.fullNames + " " + item.surname}
                        </div>
                      </div>
                      <div style={{ marginTop: 5, marginLeft: 10 }}>
                        <div style={{ fontSize: 10, fontWeight: "bold" }}>
                          Contact Number:
                        </div>
                        <div style={{ fontSize: 12, marginTop: 3 }}>
                          {item.cellNumber}
                        </div>
                      </div>
                      <div style={{ marginTop: 5, marginLeft: 10 }}>
                        <div style={{ fontSize: 10, fontWeight: "bold" }}>
                          Email Address:
                        </div>
                        <div style={{ fontSize: 12, marginTop: 3 }}>
                          {item.emailAddress}
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        flex: 0.6,
                        display: "flex",
                        flexDirection: "column",
                        borderRightStyle: "solid",
                        borderRightWidth: 1,
                        height: "90%",
                        borderColor: "#00000050",
                      }}
                    >
                      <div
                        style={{
                          // marginTop: 10,
                          marginLeft: 10,
                          fontWeight: "bold",
                          fontSize: 14,
                        }}
                      >
                        SECTION 21 INFO
                      </div>
                      <div
                        style={{
                          flex: 1,

                          display: "flex",
                          justifyContent: "center",
                          fontSize: 16,
                          fontWeight: "normal",
                          // alignItems: "center",
                        }}
                      >
                        <div
                          style={{
                            flex: 0.25,
                            maxWidth: "25%",
                            overflowX: "clip",
                          }}
                        >
                          <div style={{ marginTop: 10, marginLeft: 10 }}>
                            <div style={{ fontSize: 10, fontWeight: "bold" }}>
                              DATE CREATED
                            </div>
                            <div style={{ marginTop: 3 }}>{item.createdOn}</div>
                          </div>
                          <div style={{ marginTop: 10, marginLeft: 10 }}>
                            <div style={{ fontSize: 10, fontWeight: "bold" }}>
                              REFERENCE NO
                            </div>
                            <div style={{ marginTop: 3, fontSize: 12 }}>
                              {item.id}
                            </div>
                          </div>
                        </div>
                        <div style={{ flex: 0.25 }}>
                          <div style={{ marginTop: 10, marginLeft: 10 }}>
                            <div style={{ fontSize: 10, fontWeight: "bold" }}>
                              LINKED STORE
                            </div>
                            <div style={{ marginTop: 3, fontSize: 12 }}>
                              {item.storeName}
                            </div>
                          </div>
                          <div style={{ marginTop: 10, marginLeft: 10 }}>
                            <div style={{ fontSize: 10, fontWeight: "bold" }}>
                              STORE ADDRESS
                            </div>
                            <div style={{ marginTop: 3, fontSize: 12 }}>
                              {item.storeAddress}
                            </div>
                          </div>
                        </div>
                        <div style={{ flex: 0.25 }}>
                          <div style={{ marginTop: 10, marginLeft: 10 }}>
                            <div style={{ fontSize: 10, fontWeight: "bold" }}>
                              REASON FOR REQUEST
                            </div>
                            <div style={{ marginTop: 3, fontSize: 12 }}>
                              {item.diagnosis}
                            </div>
                          </div>
                        </div>
                        <div style={{ flex: 0.25 }}>
                          <div style={{ marginTop: 10, marginLeft: 10 }}>
                            <div
                              style={{
                                fontSize: 10,
                                fontWeight: "bold",
                                width: "100%",
                                textAlign: "center",
                              }}
                            >
                              STATUS
                            </div>
                            <div
                              style={{
                                marginTop: 3,
                                fontSize: 12,
                                width: "100%",
                                textAlign: "center",
                              }}
                            >
                              {item.status}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div
                      style={{
                        flex: 0.2,
                        backgroundColor: BlackAndWhite.primary,
                        height: "100%",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-evenly",
                        flexDirection: "column",
                      }}
                    >
                      <div style={{ color: BlackAndWhite.secondary }}>
                        ACTIONS
                      </div>
                      <BaseButtons
                        invert={true}
                        mini={true}
                        label={"MANAGE"}
                        marginTopFalse={true}
                        height={40}
                        size={"80%"}
                      />
                    </div>
                  </div>
                ) : null;
              })
            : null
          : null}
      </div>
      {slectedSection21 ? (
        <Section21Manage
          setClose={setSelectedSection21}
          selectedSection21={slectedSection21}
          admin={admin}
          setLoading={setLoading}
          setRefresh={setRefresh}
          refresh={refresh}
        />
      ) : null}
    </div>
  );
};

export default Section21Display;
